export interface IDexeroHelp {
  lastGetHelpTrigger?: IjQueryElm;
  lastGetHelpUrl?: string;
  lastHelpType?: 'box' | 'popup' | 'tab';

  _helpBindings(): void;
  _resetHelpBox(close?: boolean): void;
  _resetHelpModal(): void;
  _resetHelpSidebar(close?: boolean): void;
  activateHelp(noHelpElemsOnPage: boolean): void;
  buildInitialHelpTooltip(): void;
  closeHelpBox(): void;
  closeHelpSidebar(): void;
  deactivateHelp(): void;
  dismissHelpInitTooltip(): void;
  editHelpContent(helpKey: string, dataBundleId: string, formIdentifier?: string): void;
  handleMenuOverflow(): void;
  hideHelpOverlay(): void;
  initHelp(): void;
  loadHelpFieldUsage(
    formIdentifier: string,
    fieldIdentifier: string,
    targetContainer: IjQueryElmOrHtmlElm
  ): void;
  loadHelpPageUsage(
    formIdentifier: string,
    pageIdentifier: string,
    targetContainer: IjQueryElmOrHtmlElm
  ): void;
  loadHelpStructureItem(
    formIdentifier: string,
    structureItem: string,
    targetContainer: IjQueryElmOrHtmlElm
  ): void;
  showHelp(url: string, type?: 'box' | 'popup' | 'tab'): void;
  toggleHelp(triggerElm: IjQueryElmOrHtmlElm): void;
  toggleHelpMode(button: IjQueryElmOrHtmlElm, tunOn?: boolean): void;
}

const DexeroHelp: IDexeroHelp = {
  lastGetHelpTrigger: $({}) as IjQueryElm,
  lastGetHelpUrl: '',
  lastHelpType: 'box',

  _helpBindings() {
    $('body')
      .on('click', '.help-mode-button', (e) => {
        window.DexeroCoreApp.toggleHelpMode($(e.currentTarget));
      })
      .on('click', '.help-trigger-button', (e) => {
        e.stopImmediatePropagation();
        e.preventDefault();
        window.DexeroCoreApp.dismissHelpInitTooltip();
        window.DexeroCoreApp.toggleHelp($(e.currentTarget));
      })
      .on('hidden.bs.modal', '#help-modal', function hiddenBsModal(e) {
        // There can be a summernote modal inside the help modal,
        // make sure closing summer modal does not close the help modal
        if (this === e.target) {
          window.DexeroCoreApp._resetHelpModal();
        } else {
          $('body').addClass('modal-open');
        }
      });
  },

  // Reset hep box
  _resetHelpBox(close = false) {
    // Modal Elements
    const $box = $('#help-display-box');
    const $boxLoading = $box.find('.loading');
    const $dataContainer = $box.find('.data-container');
    const $saveButton = $box.find('button.save');
    const $backButton = $box.find('button.back');
    const $processingButton = $box.find('button.processing');
    // Empty elements
    if (close) {
      $box.slideUp();
    }
    $dataContainer.empty().addClass('hide').attr('aria-hidden', 'true');
    $boxLoading.removeClass('hide').attr('aria-hidden', 'false');
    $saveButton.addClass('hide').attr('aria-hidden', 'true');
    $backButton.addClass('hide').attr('aria-hidden', 'true');
    $processingButton.addClass('hide homeslice').attr('aria-hidden', 'true');
  },

  // Reset help modal
  _resetHelpModal() {
    // Modal Elements
    const $modal = $('#help-modal');
    const $modalLoading = $modal.find('.loading');
    const $dataContainer = $modal.find('.data-container');
    const $saveButton = $modal.find('button.save');
    const $backButton = $modal.find('button.back');
    const $processingButton = $modal.find('button.processing');
    // Empty elements
    $dataContainer.empty();
    $modalLoading.removeClass('hide').attr('aria-hidden', 'false');
    $dataContainer.addClass('hide').attr('aria-hidden', 'true');
    $saveButton.addClass('hide').attr('aria-hidden', 'true');
    $backButton.addClass('hide').attr('aria-hidden', 'true');
    $processingButton.addClass('hide').attr('aria-hidden', 'true');
  },

  // Reset sidebar
  _resetHelpSidebar(close = false) {
    // Modal Elements
    const $sidebar = $('#help-sidebar');
    const $boxLoading = $sidebar.find('.loading');
    const $dataContainer = $sidebar.find('.data-container');
    const $saveButton = $sidebar.find('button.save');
    const $backButton = $sidebar.find('button.back');
    const $processingButton = $sidebar.find('button.processing');
    // Empty elements
    if (close) {
      $sidebar.removeClass('open');
      $('body').removeClass('no-scroll');
    }
    $dataContainer.empty().addClass('hide').attr('aria-hidden', 'true');
    $boxLoading.removeClass('hide').attr('aria-hidden', 'false');
    $saveButton.addClass('hide').attr('aria-hidden', 'true');
    $backButton.addClass('hide').attr('aria-hidden', 'true');
    $processingButton.addClass('hide homeslice').attr('aria-hidden', 'true');
  },

  activateHelp(noHelpElemsOnPage) {
    // If overlay is visible it means help is already active, and a re-init might be fired by an ajax call
    if ($('#help-mode-overlay').is(':visible')) {
      return;
    }
    const userOptions = window.DexeroCoreApp.getUserOptions();
    const { langObj = {} } = userOptions;
    const { deactivateHelpModeText, noHelpElemsOnPageText, helpModeHasBeenActivatedText } = langObj;
    const $body = $('body');
    const $button = $body.find('.help-mode-button');
    const showInitialHelpTooltip = window.Cookies.get('dexeroHelpTooltipDismissed') !== 'true';

    $body.addClass('help-mode');
    $button
      .addClass('enabled')
      .removeData('original-title')
      .data('original-title', deactivateHelpModeText)
      .attr('data-original-title', deactivateHelpModeText)
      .tooltip('hide');
    if (noHelpElemsOnPage) {
      window.DexeroCoreApp.userToastMsg('info', noHelpElemsOnPageText, '');
    } else if (showInitialHelpTooltip) {
      window.DexeroCoreApp.buildInitialHelpTooltip();
    }
    window.Cookies.set('dexeroHelpEnabled', 'true', { expires: 1 });
    window.DexeroCoreApp.userToastMsg('info', helpModeHasBeenActivatedText, '');
  },

  buildInitialHelpTooltip() {
    const userOptions = window.DexeroCoreApp.getUserOptions();
    const { langObj = {} } = userOptions;
    const { clickForHelpText, helpModeHasBeenActivatedText, iUnderstandText } = langObj;
    const firstHelpTriggerButton = $('body').find('.help-trigger-button').first().find('> .fa');

    function buildToolTipContent() {
      return `<h3>${helpModeHasBeenActivatedText}</h3><p>${clickForHelpText}</p><p class="text-right"><button class="btn btn-sm roundless btn-success help-pulse-box-shadow" type="button" onClick="window.DexeroCoreApp.dismissHelpInitTooltip();">${iUnderstandText}</button></p>`;
    }

    $(firstHelpTriggerButton)
      .addClass('help-init-tooltip-trigger')
      .tooltip({
        container: 'body',
        html: true,
        placement: 'bottom',
        template:
          '<div class="tooltip color-block help-init-tooltip dirty-navy" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
        title: buildToolTipContent,
        trigger: 'click',
      })
      .tooltip('show');
  },

  // Close help box
  closeHelpBox() {
    window.DexeroCoreApp._resetHelpBox(true);
  },

  // Close sidebar
  closeHelpSidebar() {
    window.DexeroCoreApp._resetHelpSidebar(true);
  },

  deactivateHelp() {
    const userOptions = window.DexeroCoreApp.getUserOptions();
    const { langObj = {} } = userOptions;
    const { activateHelpModeText, helpModeHasBeenDeactivatedText } = langObj;
    const $body = $('body');
    const $button = $body.find('.help-mode-button');

    $body.removeClass('help-mode');
    $button
      .removeClass('enabled')
      .removeData('original-title')
      .data('original-title', activateHelpModeText)
      .attr('data-original-title', activateHelpModeText)
      .tooltip('show');
    window.Cookies.set('dexeroHelpEnabled', 'false', { expires: 1 });
    window.DexeroCoreApp.userToastMsg('info', helpModeHasBeenDeactivatedText, '');
  },

  dismissHelpInitTooltip() {
    const $trigger = $('.help-init-tooltip-trigger');
    $trigger.tooltip('destroy');
    window.DexeroCoreApp.hideHelpOverlay();
    window.Cookies.set('dexeroHelpTooltipDismissed', 'true', { expires: 1 });
  },

  editHelpContent(helpKey: string, dataBundleId: string, formIdentifier = '') {
    const userOptions = window.DexeroCoreApp.getUserOptions();
    const { baseURL, helpFormIdentifier, lang, langObj = {} } = userOptions;
    const { successCompletionMsgText, errorText } = langObj;

    let $helpContainer: IjQueryElm | undefined;
    let resetHelpContainerFunc: any;

    if (window.DexeroCoreApp.lastHelpType === 'box') {
      $helpContainer = $('#help-display-box');
      resetHelpContainerFunc = window.DexeroCoreApp._resetHelpBox;
    } else if (window.DexeroCoreApp.lastHelpType === 'popup') {
      $helpContainer = $('#help-modal');
      resetHelpContainerFunc = window.DexeroCoreApp._resetHelpModal;
    } else if (window.DexeroCoreApp.lastHelpType === 'tab') {
      $helpContainer = $('#help-sidebar');
      resetHelpContainerFunc = window.DexeroCoreApp._resetHelpSidebar;
    }

    if (!$helpContainer) {
      return;
    }

    const $loading = $helpContainer.find('.loading');
    const $dataContainer = $helpContainer.find('.data-container');
    const $backButton = $helpContainer.find('button.back');
    const $saveButton = $helpContainer.find('button.save');
    const $processingButton = $helpContainer.find('button.processing');
    const loadFormUrl = `${baseURL}help-${helpFormIdentifier}/${lang}/a/form?ajax=true&dataBundleId=${dataBundleId}&hk=${helpKey}&fi=${formIdentifier}`;

    // Reset container
    resetHelpContainerFunc();

    if (window.DexeroCoreApp.lastHelpType === 'tab') {
      const windowHeight = $(window).height() || 0;
      const wH = windowHeight - 100;
      $('body').addClass('no-scroll');
      /* stylelint-disable-next-line declaration-block-trailing-semicolon */
      $helpContainer.addClass('open').css({ height: wH });
    }
    // Enable back button
    if (window.DexeroCoreApp.lastGetHelpUrl && window.DexeroCoreApp.lastHelpType) {
      $backButton
        .removeClass('hide')
        .attr('aria-hidden', 'false')
        .off('click')
        .on('click', () => {
          resetHelpContainerFunc();
          window.DexeroCoreApp.showHelp(
            window.DexeroCoreApp.lastGetHelpUrl || '',
            window.DexeroCoreApp.lastHelpType
          );
          $backButton.addClass('hide').attr('aria-hidden', 'true');
        });
    }

    // Get the form
    $.get(loadFormUrl).done((responseData) => {
      $dataContainer.append(responseData);
      // Setup form validation
      const $form = $dataContainer.find('form');
      const action = $form.attr('action') as string;
      $form.on('submit', (e) => {
        e.preventDefault();
      });
      window.DexeroCoreApp.handleValidation();

      // Setup save button click event
      $saveButton
        .removeClass('hide')
        .attr('aria-hidden', 'false')
        .off('click')
        .on('click', (e) => {
          // On save click
          if ($form.valid() && !$(e.currentTarget).hasClass('disabled')) {
            $saveButton.addClass('hide').attr('aria-hidden', 'true');
            $processingButton.removeClass('hide').attr('aria-hidden', 'false');
            window.DexeroCoreApp.blockUI($form);
            $.post(action, $form.serialize()).done((postResponseData) => {
              if (postResponseData && postResponseData.success === 'true') {
                window.DexeroCoreApp.userToastMsg('success', successCompletionMsgText, '');
                resetHelpContainerFunc();
                $backButton.addClass('hide').attr('aria-hidden', 'true');
                if (window.DexeroCoreApp.lastGetHelpUrl && window.DexeroCoreApp.lastHelpType) {
                  if (
                    window.DexeroCoreApp.lastHelpType === 'tab' &&
                    window.DexeroCoreApp.lastGetHelpTrigger
                  ) {
                    window.DexeroCoreApp.lastGetHelpTrigger.trigger('click');
                  } else {
                    window.DexeroCoreApp.showHelp(
                      window.DexeroCoreApp.lastGetHelpUrl,
                      window.DexeroCoreApp.lastHelpType
                    );
                  }
                }
              } else {
                window.DexeroCoreApp.userToastMsg('error', errorText, '');
                window.DexeroCoreApp.blockUI(undefined, $form, true);
                $saveButton.removeClass('hide');
                $processingButton.addClass('hide');
                window.DexeroCoreApp.displayJsonErrors(postResponseData.formError);
                if ($helpContainer) {
                  $helpContainer.animate({ scrollTop: 0 }, 'fast');
                }
              }
            });
          }
        });
      // Show form
      $dataContainer.removeClass('hide').attr('aria-hidden', 'false');
      $loading.addClass('hide').attr('aria-hidden', 'true');
    });
  },

  handleMenuOverflow() {
    const $formStructureMenu = $('#form-structure-menu');
    const $formStructureSubmenuHolder = $('#form-structure-submenu-holder');
    const $formStructureSubmenu = $formStructureSubmenuHolder.find('#form-structure-submenu');
    const $formStructureSubmenuLis = $formStructureSubmenu.find('li');

    // Hide overflow menu
    $formStructureSubmenuHolder.addClass('hide');
    // Add overflow lis to main menu
    $formStructureMenu.append($formStructureSubmenuLis);

    const $formStructureMenuLis = $formStructureMenu.find('li');
    const formStructureMenuWidth = $formStructureMenu.innerWidth() || 0;
    let totalLisWidth = 0;

    const $overFlowLis = $formStructureMenuLis.filter((_, li) => {
      totalLisWidth += $(li).outerWidth() || 0;
      return totalLisWidth > formStructureMenuWidth;
    });

    if ($overFlowLis.length > 0) {
      $formStructureSubmenu.empty().append($overFlowLis);
      $formStructureSubmenuHolder.removeClass('hide');
    }
  },

  hideHelpOverlay() {
    const $helpModeOverlay = $('#help-mode-overlay');
    $helpModeOverlay.addClass('dismissed');
  },

  initHelp() {
    if (!window.DexeroCoreApp.getUserOptions().initHelpMode) {
      return;
    }
    const formStructureMenu = $('#form-structure-menu');
    const $window = $(window);

    if (formStructureMenu.length) {
      $window.on('resize', window.DexeroCoreApp.handleMenuOverflow);
      window.DexeroCoreApp.handleMenuOverflow();
    } else {
      $window.off('resize', window.DexeroCoreApp.handleMenuOverflow);
    }

    if (window.DexeroCoreApp.getUserOptions().helpIsActive === 'off') {
      window.DexeroCoreApp.deactivateHelp();
    } else if (
      window.DexeroCoreApp.getUserOptions().helpIsActive === 'true' ||
      window.Cookies.get('dexeroHelpEnabled') === 'true'
    ) {
      const button = $('body').find('.help-mode-button').first();
      window.DexeroCoreApp.toggleHelpMode(button, true);
    }
  },

  loadHelpFieldUsage(
    formIdentifier: string,
    fieldIdentifier: string,
    targetContainer: IjQueryElmOrHtmlElm
  ) {
    const userOptions = window.DexeroCoreApp.getUserOptions();
    const { baseURL } = userOptions;
    const loadUrl = `${baseURL}help/?ajax=true&action=field_usage&fi=${formIdentifier}&fei=${fieldIdentifier}`;
    const $targetContainer = $(targetContainer) as IjQueryElm;
    window.DexeroCoreApp.blockUI($targetContainer);
    $.get(loadUrl).done((responseData) => {
      $targetContainer.empty().append(responseData).slideDown();
      window.DexeroCoreApp.blockUI(undefined, $targetContainer, true);
    });
  },

  loadHelpPageUsage(
    formIdentifier: string,
    pageIdentifier: string,
    targetContainer: IjQueryElmOrHtmlElm
  ) {
    const userOptions = window.DexeroCoreApp.getUserOptions();
    const { baseURL } = userOptions;
    const loadUrl = `${baseURL}help/?ajax=true&action=page_usage&fi=${formIdentifier}&pi=${pageIdentifier}`;
    const $targetContainer = $(targetContainer) as IjQueryElm;
    window.DexeroCoreApp.blockUI($targetContainer);
    $.get(loadUrl).done((responseData) => {
      $targetContainer.empty().append(responseData).slideDown();
      window.DexeroCoreApp.blockUI(undefined, $targetContainer, true);
    });
  },

  loadHelpStructureItem(
    formIdentifier: string,
    structureItem: string,
    targetContainer: IjQueryElmOrHtmlElm
  ) {
    const userOptions = window.DexeroCoreApp.getUserOptions();
    const { baseURL } = userOptions;
    const loadUrl = `${baseURL}help/?ajax=true&action=form_structure&fi=${formIdentifier}&si=${structureItem}`;
    const $accordionList = $('#accordionList');
    const $tabContainer = $('#tabContainer');
    const $tabDivs = $tabContainer.find('.tab-pane');
    const requestedTabid = `${structureItem}_tabID`;
    const $requestedTab = $tabDivs.filter((_, div) => $(div).attr('id') === requestedTabid);
    const $pageLinks = $accordionList.find('.page-link') as JQuery<HTMLAnchorElement>;
    const requestedLinkId = `pageLink${structureItem}`;
    const $requestedLink = $pageLinks.filter((_, a) => $(a).attr('id') === requestedLinkId);

    window.DexeroCoreApp.lastGetHelpTrigger = $requestedLink.find('a') as IjQueryElm;
    window.DexeroCoreApp.lastGetHelpUrl = loadUrl;
    window.DexeroCoreApp.lastHelpType = 'tab';

    $pageLinks.removeClass('active');
    $requestedLink.addClass('active');

    $tabDivs.removeClass('active in');
    $requestedTab.addClass('active in');

    window.DexeroCoreApp.blockUI($tabContainer);
    $.get(loadUrl).done((responseData) => {
      $requestedTab.empty().append(responseData);
      window.DexeroCoreApp.blockUI(undefined, $tabContainer, true);
      window.DexeroCoreApp.publish('/tab/content/change', [targetContainer]);
    });
  },

  showHelp(url: string, type = 'popup') {
    // Modal pop up mode
    if (type === 'popup') {
      const $modal = $('#help-modal');
      const $modalLoading = $modal.find('.loading');
      const $dataContainer = $modal.find('.data-container');
      $modal.modal('show');
      $.get(url).done((responseData) => {
        $dataContainer.append(responseData).removeClass('hide').attr('aria-hidden', 'false');
        $modalLoading.addClass('hide').attr('aria-hidden', 'true');
      });
    } else if (type === 'box') {
      const $box = $('#help-display-box');
      const $boxLoading = $box.find('.loading');
      const $dataContainer = $box.find('.data-container');
      // SetupBox
      $boxLoading.removeClass('hide').attr('aria-hidden', 'false');
      $dataContainer.addClass('hide').attr('aria-hidden', 'true').empty();
      if (!$box.is(':visible')) {
        $box.slideDown();
      }
      $.get(url).done((responseData) => {
        $boxLoading.addClass('hide').attr('aria-hidden', 'true');
        $dataContainer.append(responseData).removeClass('hide').attr('aria-hidden', 'false');
        ($box as any).scrollTo();
      });
    } else if (type === 'tab') {
      window.DexeroCoreApp.closeHelpSidebar();
    }
  },

  toggleHelp(triggerElm: IjQueryElmOrHtmlElm) {
    const userOptions = window.DexeroCoreApp.getUserOptions();
    const { baseURL } = userOptions;
    const $triggerElm = $(triggerElm);
    const $helpBoundElement = $triggerElm.parent('.has-help-element');
    const helpKey = $helpBoundElement.data('help-key') || '';
    const helpType = $helpBoundElement.data('help-type') || 'box';
    const helpLinkedId = $helpBoundElement.data('help-linked-id') || '';
    // const helpLinkedIdentifier = $helpBoundElement.data('help-linked-identifier') || '';
    const getHelpUrl = `${baseURL}help/?ajax=true&action=help&hk=${helpKey}&ht=${helpType}&hli=${helpLinkedId}&hlif=;{helpLinkedIdentifier}`;

    window.DexeroCoreApp.lastGetHelpUrl = getHelpUrl;
    window.DexeroCoreApp.lastHelpType = helpType;

    // If overlay is still open, close it
    window.DexeroCoreApp.hideHelpOverlay();
    console.info(`%c helpKey: ${helpKey}`, 'background: #dde6f0; color: #34495e');
    if (typeof helpKey !== 'undefined' && helpKey !== null && helpKey !== '') {
      window.DexeroCoreApp.showHelp(getHelpUrl, helpType);
    }
  },

  toggleHelpMode(button, tunOn = false) {
    const userOptions = window.DexeroCoreApp.getUserOptions();
    const { langObj = {} } = userOptions;
    const { helpText } = langObj;
    const $button = $(button) as IjQueryElm;
    const isActive = $button.hasClass('enabled');
    const $body = $('body');
    const $elementsWithHelp = $body.find('.has-help-element');
    const noHelpElemsOnPage = !$elementsWithHelp.length;
    const helpTriggerButton = `<span tabIndex="0" class="help-trigger-button hover-cursor"><span class="fa fa-life-ring" aria-hidden="true"></span><span class="sr-only">${helpText}</span></span>`;
    const helpModeOverlay = `<div class="help-mode-overlay ${
      window.Cookies.get('dexeroHelpTooltipDismissed') === 'true' || noHelpElemsOnPage
        ? 'dismissed'
        : ''
    }" id="help-mode-overlay"></div>`;

    // Make sure there is an overlay elment present
    if (!$body.find('> div#help-mode-overlay').length) {
      $body.prepend(helpModeOverlay);
    }

    // Make sure every help section has a help trigger button inside
    $elementsWithHelp.each((_, elm) => {
      const $elm = $(elm);
      const isButton = $elm.is('button');
      const helpKey = $elm.data('help-key') || false;
      const helpType = $elm.data('help-type') || 'box';
      const doPrepend =
        (isButton && !$elm.siblings('.help-trigger-button').length) ||
        (!isButton && !$elm.find('> .help-trigger-button').length);
      // If not help trigger exists, insert one
      if (doPrepend) {
        if (!isButton) {
          $elm.prepend(helpTriggerButton);
          // We need to wrap buttons for click triggers
        } else if (isButton) {
          const divClass = $elm.parent('div').hasClass('.btn-group')
            ? 'has-help-element inline-block pull-left'
            : 'has-help-element inline-block';
          $elm
            .wrap(`<div class="${divClass}"></div>`)
            .parent('div')
            .data('help-key', helpKey)
            .data('help-type', helpType)
            .prepend(helpTriggerButton);
        }
      } else if (isButton) {
        $elm.siblings('.help-trigger-button').remove().end().unwrap('div.has-help-element');
      }
    });

    // Activate via module init
    if (tunOn) {
      window.DexeroCoreApp.activateHelp(noHelpElemsOnPage);
      return;
    }
    // Check if help mode is currently active
    if (isActive) {
      window.DexeroCoreApp.deactivateHelp();
    } else {
      window.DexeroCoreApp.activateHelp(noHelpElemsOnPage);
    }
  },
};

export default DexeroHelp;
